import type { FieldValues } from "react-hook-form";
import type {
  CommonComponentProps,
  ControlledInputComponentProps,
  InputComponentProps,
  SituationalComponentProps,
} from "../../utils/component-props";
import type { InputWithLabelsExposedProps } from "../_components/InputWithLabels/types";

/**
 * Props for the CronInput component
 */
export type CronInputProps = Partial<CommonComponentProps> &
  Omit<InputComponentProps<"fieldset">, "value" | "onChange"> &
  Pick<
    SituationalComponentProps,
    "error" | "invalidMessage" | "isInline" | "isFluid"
  > & {
    /** Current cron expression value */
    value?: string;
    /** Callback function triggered when the cron expression changes */
    onChange?: (value: string) => void;
  };

export type ControlledCronInputProps<T extends FieldValues> =
  ControlledInputComponentProps<T, CronInputProps> &
    InputWithLabelsExposedProps;

export const CronIntervalType = {
  WEEKLY: "weekly",
  MONTHLY: "monthly",
} as const;
export type CronIntervalTypeType =
  (typeof CronIntervalType)[keyof typeof CronIntervalType];

export const CronDayType = {
  MON: "MON",
  TUE: "TUE",
  WED: "WED",
  THU: "THU",
  FRI: "FRI",
  SAT: "SAT",
  SUN: "SUN",
} as const;
export type CronDayTypeType = (typeof CronDayType)[keyof typeof CronDayType];
